import type { App } from '../../app.js';
import { h, button } from '../dom.js';

export function buildPauseOverlay(app: App): HTMLElement {
  const online = !!app.raceCtx?.online;

  const slider = (label: string, get: () => number, set: (v: number) => void) => {
    const input = h('input', {
      type: 'range',
      min: '0',
      max: '100',
      value: String(Math.round(get() * 100)),
      style: 'width: 140px;',
    }) as HTMLInputElement;
    input.addEventListener('input', () => {
      set(Number(input.value) / 100);
      app.audio.applyVolumes();
      app.saveAll();
    });
    return h(
      'div',
      { class: 'row', style: 'justify-content:space-between; gap: 18px;' },
      h('span', { class: 'subtle', text: label }),
      input
    );
  };

  return h(
    'div',
    { class: 'screen screen-dim', style: 'z-index:50;' },
    h(
      'div',
      { class: 'panel col', style: 'min-width:340px; align-items:stretch; text-align:center;' },
      h('div', { class: 'h1', text: 'PAUSED', style: 'margin-bottom:8px;' }),
      online
        ? h('div', {
            class: 'subtle',
            text: 'The race continues without you — hurry back.',
            style: 'margin-bottom:10px;',
          })
        : null,
      button(
        'RESUME',
        () => {
          app.audio.play('ui_confirm');
          app.setPaused(false);
        },
        'primary focusable'
      ),
      slider('MASTER', () => app.settings.masterVolume, (v) => (app.settings.masterVolume = v)),
      slider('MUSIC', () => app.settings.musicVolume, (v) => (app.settings.musicVolume = v)),
      slider('EFFECTS', () => app.settings.sfxVolume, (v) => (app.settings.sfxVolume = v)),
      button(
        online ? 'EXIT RACE (ABANDON)' : 'EXIT RACE',
        () => {
          app.audio.play('ui_back');
          app.quitRace();
        },
        'danger focusable'
      )
    )
  );
}
